import { useMemo } from 'react'
import {
  type NavMenuHierarchyL1,
  type NavMenuHierarchyL2,
} from '../../../../../gin-and-tonic/containers/nav/utils/NavMenuHierarchy'
import { useNavHierarchyAdminV3 } from '../../../../../gin-and-tonic/containers/nav-v3/useNavHierarchyAdminDataV3'

// Builds a route-name -> i18n-label-id map by flattening the admin v3 nav
// hierarchy. Access checks are skipped so every navigable admin page contributes
// a label, even ones the current page's gating would hide from the sidebar. Used
// to give recently-viewed entries their proper nav label, falling back to a
// prettified path when a page (e.g. a detail view) has no nav entry.
export const useAdminNavLabels = (): Map<string, string> => {
  const { navMenuHierarchy } = useNavHierarchyAdminV3(false)

  return useMemo(() => {
    const labels = new Map<string, string>()

    const visit = (node: NavMenuHierarchyL1 | NavMenuHierarchyL2) => {
      if (node.route && !labels.has(node.route)) labels.set(node.route, node.name)
      // subRoutes share their owner's label — they're alternate URLs for the
      // same nav destination.
      for (const subRoute of (node as NavMenuHierarchyL2).subRoutes ?? []) {
        if (!labels.has(subRoute)) labels.set(subRoute, node.name)
      }
      for (const child of node.children ?? []) visit(child)
    }

    for (const section of navMenuHierarchy.sections) {
      for (const l1 of section.l1s) visit(l1)
    }

    return labels
  }, [navMenuHierarchy])
}
